import {useEffect} from 'react';

const CalendlyEmbed = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="flex flex-col items-center bg-gradient-to-tr from-[#4C68F699] to-[#4C68F6] pt-[104px] pb-[100px] text-white">
      <div className="mt-8 flex max-w-[790px] flex-col items-center gap-4 text-center">
        <div className="lg:text-4.5xl text-center text-3xl font-semibold">
          Schedule a call with us.
        </div>
        <div className="text-brand-gray px-1 text-center font-sans text-base md:px-16 lg:px-10 lg:text-xl">
          Let's talk about how Polar Signals can help you optimize your infrastructure and save
          costs.
        </div>
      </div>
      <div
        className="calendly-inline-widget mt-4 h-[780px] w-full pl-4 pr-4 md:pl-8 md:pr-8 lg:pl-0 lg:pr-0"
        data-url="https://calendly.com/frederic-branczyk/polar-signals-introduction"
      ></div>
    </div>
  );
};

export default CalendlyEmbed;
